export interface CreateBookingRequest {
  prerequisiteQuestionId?: number;
  testEventId: number;
  userId: number;
}
